import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import * as _ from 'lodash';

//Import froala plugins
import 'froala-editor/js/plugins.pkgd.min';

@Component({
  selector: 'mapfre-auditlib-textarea',
  templateUrl: './textarea.component.html',
  styleUrls: ['./textarea.component.scss']
})
export class TextareaComponent implements OnInit {

  @Input()
  label

  @Input()
  form

  @Input()
  icon

  @Input()
  skipHighlighter=false

  @Input()
  froalaOptions = {
    key: 'xGE6oB4H3H4B10D6C4fLUQZf1ASFb1EFRNh1Hb1BCCQDUHnA8B6E5B4B1D3C3A1B8B5==',
    language: 'es',
    events: {
      'image.beforeUpload': function (files, editor) {
        if (files.length) {
          // Create a File Reader.
          var reader = new FileReader();

          // Set the reader to insert images when they are loaded.
          reader.onload = (e: any) => {
            var result = e.target.result;
            this.image.insert(result, null, null, this.image.get());
          };

          // Read image as base64.
          reader.readAsDataURL(files[0]);
        }

        this.popups.hideAll();
        // Stop default upload chain.
        return false
      }
    },
    toolbarButtons:{
      'moreText': {
        'buttons': ['bold', 'italic', 'underline', 'strikeThrough', 'subscript', 'superscript', 'fontFamily', 'fontSize', 'textColor', 'backgroundColor', 'inlineClass', 'inlineStyle', 'clearFormatting']
      },
      'moreParagraph': {
        'buttons': ['alignLeft', 'alignCenter', 'formatOLSimple', 'alignRight', 'alignJustify', 'formatOL', 'formatUL', 'paragraphFormat', 'paragraphStyle', 'lineHeight', 'outdent', 'indent', 'quote']
      },
      'moreRich': {
        'buttons': ['fullscreen']
      }
    }
  }

  _model;
  @Input()
  get model() {
    return this._model
  }
  set model(value) {
    this._model = value;
    this.modelChange.emit(this._model);
  }

  @Input() froala = true;

  _readonly;
  @Input()
  get readonly() {
    return this._readonly
  }
  set readonly(value) {
    this._readonly = value;
    if (value) {
      _.assign(this.froalaOptions.events, {
        'initialized': (editor) => {
          editor._editor.edit.off();
        }
      });
    }
  }

  @Output()
  modelChange = new EventEmitter();



  constructor() { }

  ngOnInit() {  
    if (!this.froala) {
      this.froalaOptions = null;
    }
  }

}
